export const KIOSKO_BUTTON_CLASSES =
  'kiosko:w-[698px] kiosko:!rounded-[56px] kiosko:h-[114px] kiosko:text-kiosko-m';

// Scales the kit fields (Input, Select, Datepicker) rendered inside `.form-field-wrapper`
// descendants of the element that carries these classes. The kit exposes no size props,
// so the floating label goes through its CSS variables and the rest through descendant selectors.
// The width variables are set here because legacy FormFieldWrapper only sets them below the
// laptop breakpoint, and kiosk screens can be wider.
export const KIOSKO_FIELD_CLASSES = [
  'kiosko:[--field-max-width:100%]',
  'kiosko:[--field-width:100%]',
  'kiosko:[--field-label-font-size:28px]',
  'kiosko:[--field-label-raised-font-size:24px]',
  'kiosko:[--field-label-top:34px]',
  'kiosko:[--field-label-raised-top:-15px]',
  'kiosko:[--field-placeholder-font-size:28px]',
  'kiosko:[--field-top-label-font-size:24px]',
  'kiosko:[--chekin-select-menu-max-height:540px]',
  'kiosko:[&_.form-field-wrapper_.h-12]:h-[106px]',
  'kiosko:[&_.form-field-wrapper_.min-h-12]:min-h-[106px]',
  'kiosko:[&_.form-field-wrapper_.grid:has(input[id$=-month])]:grid-cols-[minmax(0,1fr)_minmax(200px,260px)_minmax(0,1fr)]',
  'kiosko:[&_.form-field-wrapper_input]:text-kiosko-s',
  'kiosko:[&_.form-field-wrapper_button[id$=-trigger]]:text-kiosko-s',
  'kiosko:[&_.form-field-wrapper_button[id$=-trigger]_svg]:size-7',
  'kiosko:[&_.form-field-wrapper_[role=combobox]_svg]:size-7',
  'kiosko:[&_.form-field-wrapper_[role=combobox]~svg]:size-7',
  'kiosko:[&_.form-field-wrapper_ul[role=listbox]]:max-h-[540px]',
  'kiosko:[&_.form-field-wrapper_[role=option]]:py-6',
  'kiosko:[&_.form-field-wrapper_[role=option]]:text-kiosko-xs',
  'kiosko:[&_.form-field-wrapper_[role=option]]:leading-tight',
].join(' ');

// Row and list heights of the kit InfiniteScrollSelect. Its rows are virtualized with
// inline heights, so CSS cannot scale them.
export const KIOSKO_INFINITE_SELECT_SIZE = {itemHeight: 88, listHeight: 540};
